import { LucideDatabase, X } from "lucide-react"
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../ui/alert-dialog"
import { ChangeDbForm } from "./ChangeDbForm";
import { useState } from "react";
import { MyTooltip } from "../MyTooltip";

interface ChangeDbDialogProps {
    appName: string;
}

export const ChangeDbDialog = ({ appName }: ChangeDbDialogProps) => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
            <AlertDialogTrigger className="flex items-center">
                <MyTooltip text="Alterar Banco">
                    <LucideDatabase onClick={() => setIsOpen(true)} />
                </MyTooltip>
            </AlertDialogTrigger>
            <AlertDialogContent className="w-4/5 rounded-xl sm:w-2/6 sm:h-1/3">
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex justify-between items-center px-2">
                        <span className="text-primary">
                            Informe o nome do banco
                        </span>
                        <div>
                            <X onClick={() => setIsOpen(false)} className="text-muted-foreground cursor-pointer" />
                        </div>
                    </AlertDialogTitle>
                    <div className="w-full h-full flex">
                        <ChangeDbForm setIsOpen={setIsOpen} appName={appName} />
                    </div>

                    <AlertDialogDescription></AlertDialogDescription>
                </AlertDialogHeader>
            </AlertDialogContent>
        </AlertDialog>
    )
}